module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "illustration"
  }, [_c('div', {
    staticClass: "illustration-bg"
  })]), _c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("轻松融合多家 CDN 服务")]), _c('p', [_vm._v("杭州点智连科技有限公司，可按任意比例配置调度各 CDN 厂商流量")]), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "http://console.oncdp.com/#/login",
      "target": "_blank"
    }
  }, [_vm._v("立即体验")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-080c09d1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/banner.vue
// module id = 44
// module chunks = 0